import React from "react";

const PatientInfoContext = React.createContext();
PatientInfoContext.displayName = "PatientInfoContext";

export default PatientInfoContext;
